import React from 'react';
// import Warning from '../Icons/Warning';
// import Check from '../Icons/Check';
import { isMobile } from 'react-device-detect';


function Alert(props) {
  const inline = {
    a: {
      paddingLeft: isMobile ? 0 : 5,
      textDecoration: 'underline'
    },
    bold: {
      fontWeight: 900
    },
    close: {
      // position: 'relative',
      // top: 4,
      // fontSize: 16,
    }
  }

  const fetchContinueHREF = () => {
	  if (document.referrer.includes('logon')) {
		  window.history.go(-2);
	  }
	  else if (document.referrer.includes('mycart')) {
		  window.location.href = '/mycart/home';
	  }
	  else if (document.referrer.includes('mycheckout')) {
		  window.location.href = '/mycheckout/checkout';
	  }
	  else {
		  window.history.go(-1);
	  }
  };

  return (
    <div className={props.fill ? 'flex-row flex-wrap flex-fill-start show-zoom-animation' : 'flex-row flex-wrap show-zoom-animation'}>
      <div class="grid">
        <div class="col__12-12">
          <div className={"flex flex-center align-items-center alert alert--" + props.type}>
            <span class="alert__message">
              <span style={inline.bold}>{props.bold}</span>{props.text}
              {isMobile ? <br /> : null}
              <a onClick={fetchContinueHREF} style={inline.a}>Continue Shopping</a>
            </span>
            <div className='flex-grow'></div>
            <span onClick={() => props.resetAppAlert()} style={inline.close} className={props.type === 'success' ? "mw-icon-menu-close close-alert-success close-alert" : "mw-icon-menu-close close-alert-error close-alert"}></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Alert;


// WEBPACK FOOTER //
// ./src/Components/Alert/Alert.js